import type { LocationQueryRaw, RouteLocationRaw } from 'vue-router';

const mergeFilterQuery = (
  currentQuery: Record<string, string>,
  filterQueryParams: LocationQueryRaw,
): LocationQueryRaw => {
  const nextQuery: LocationQueryRaw = {
    ...currentQuery,
    ...filterQueryParams,
  };

  for (const [key, value] of Object.entries(filterQueryParams)) {
    if (value === undefined) {
      delete nextQuery[key];
    }
  }

  return nextQuery;
};

export const buildRubricTagRoute = (
  tagUrl: string | undefined,
  filterQueryParams: LocationQueryRaw,
): RouteLocationRaw | null => {
  if (!tagUrl) {
    return null;
  }

  const currentQuery = Object.fromEntries(new URLSearchParams(window.location.search).entries());

  return {
    path: tagUrl,
    query: mergeFilterQuery(currentQuery, filterQueryParams),
  };
};
